const localization = {
    cannot_delete_default_language: '{{languageTag}} jest ustawiony jako Twój język domyślny i nie można go usunąć.',
    invalid_translation_structure: 'Nieprawidłowe schematy danych. Sprawdź swoje dane wejściowe i spróbuj ponownie.',
};
export default localization;
